import { Component } from 'react';

import { MapWithControlledZoom } from './MapWithControlledZoom';
import { $MapContainer } from './PickupPointMap.styles';
import { VisibilityObserver } from './VisibilityObserver';

interface PickupPoint {
  latitude: number;
  longitude: number;
  [key: string]: any;
}

interface SearchAddress {
  location: {
    lat: number;
    lng: number;
  };
  [key: string]: any;
}

interface IconsPath {
  point?: string;
  selectedPoint?: string;
  home?: string;
}

interface PickupPointMapProps {
  searchAddress: SearchAddress;
  iconsPath?: IconsPath;
  onSelectPickupPoint: (pickupPoint: PickupPoint) => void;
  pickupPoints: PickupPoint[];
  selectedPickupPointId?: string | null;
}

interface Bounds {
  north: number;
  east: number;
  south: number;
  west: number;
}

class PickupPointMap extends Component<PickupPointMapProps> {
  static defaultProps = {
    iconsPath: {
      point: '/images/carriers/Logo_Chrono_marker.png',
      selectedPoint: '/images/carriers/Logo_Chrono_marker_active.png',
      home: '/images/Group 14@1x.png',
    },
    selectedPickupPointId: null,
  };

  static getBounds(address: SearchAddress, pickupPoints: PickupPoint[]) {
    const bounds: Bounds = {
      north: address.location.lat,
      east: address.location.lng,
      south: address.location.lat,
      west: address.location.lng,
    };

    if (pickupPoints.length > 0) {
      pickupPoints.forEach((pickupPoint) => {
        const { latitude: lat, longitude: lng } = pickupPoint;

        if (bounds.north < lat) {
          bounds.north = lat;
        }
        if (bounds.east < lng) {
          bounds.east = lng;
        }

        if (bounds.south > lat) {
          bounds.south = lat;
        }
        if (bounds.west > lng) {
          bounds.west = lng;
        }
      });
    }

    const centerLat = address.location.lat;
    const centerlng = address.location.lng;

    return {
      bounds,
      center: { lat: centerLat, lng: centerlng },
    };
  }

  render() {
    const { searchAddress, pickupPoints } = this.props;

    if (
      !searchAddress ||
      !searchAddress.location ||
      searchAddress.location.lat === undefined
    ) {
      return null;
    }

    const boundInfo = PickupPointMap.getBounds(searchAddress, pickupPoints);

    return (
      <VisibilityObserver threshold={0}>
        {({ inView, ref }: any) => (
          <$MapContainer ref={ref}>
            <MapWithControlledZoom
              {...this.props}
              key={`${boundInfo.bounds.north - boundInfo.bounds.south}-${
                boundInfo.bounds.west - boundInfo.bounds.east
              }-${inView}`}
              center={boundInfo.center}
              bounds={boundInfo.bounds}
              pickupPoints={pickupPoints as any}
            />
          </$MapContainer>
        )}
      </VisibilityObserver>
    );
  }
}

export default PickupPointMap;
